'use es6';

import { memo, useEffect, useState } from 'react';
import { TooMuchDataException } from 'reporting-data/exceptions';
import memoize from 'transmute/memoize';
import { DEFAULT_DEBUG } from '../../constants/debug';
import { XY } from '../../constants/visualizationTypes';
import Highchart from '../../highcharts/Highchart';
import { mapVisualization } from './xyMapper';
import { XYVisualization } from './xyRecords';
import FilterOverlapsModal from './components/FilterOverlapsModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const getHighchartsOptions = memoize((...args) => mapVisualization(...args));
export const type = XY;
export const record = XYVisualization;
const MAX_SERIES = 100;
const MAX_PRODUCT = 10000;
const XyViz = ({
  visualization,
  debug = DEFAULT_DEBUG,
  gates,
  onReportVisualize,
  reportingThemes
}) => {
  const [filterOverlapsModalProps, setFilterOverlapsModalProps] = useState(null);
  const chartOptions = getHighchartsOptions(visualization, debug, gates, setFilterOverlapsModalProps, reportingThemes);
  const categoryCount = chartOptions.get('xAxis').map(axis => {
    const maybeCategories = axis.get('categories');
    return maybeCategories ? maybeCategories.count() : 0;
  }).max() || 0;
  const seriesCount = chartOptions.get('series').count();

  // Here we don't want a 0 value to allow a 10000+ category chart
  const product = Math.max(categoryCount, 1) * Math.max(seriesCount, 1);
  const isTooMuchData = product >= MAX_PRODUCT || seriesCount > MAX_SERIES;
  if (isTooMuchData) {
    throw new TooMuchDataException();
  }
  useEffect(() => {
    debug.set('Highcharts', chartOptions);
  }, [debug, chartOptions]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [filterOverlapsModalProps && /*#__PURE__*/_jsx(FilterOverlapsModal, Object.assign({}, filterOverlapsModalProps, {
      onReject: () => setFilterOverlapsModalProps(null)
    })), /*#__PURE__*/_jsx(Highchart, {
      chartOptions: chartOptions,
      onReportVisualize: onReportVisualize
    })]
  });
};
export const Render = /*#__PURE__*/memo(XyViz);